import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import planResourceModel from "src/models/plan/models/resource"
import collection from "src/hocs/collection"

const configurator = ({ planId }, { view }) => ({
  engine: entity,
  to: `resources`,
  model: planResourceModel(planId),
  query: {
    limit: -1,
    orderBy: `name asc`,
    view: view || `ALL`,
  },
})

export default config =>
  compose(
    /* Using propsflow allows to extends basic configuration */
    collection(props => ({
      ...configurator(props, config),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
